import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastSeverity = 'success' | 'info' | 'warn' | 'error'

export interface Toast {
  id: number
  severity: ToastSeverity
  summary: string
  detail?: string
  life: number
}

let nextId = 1

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])

  function show(severity: ToastSeverity, summary: string, detail?: string, life = 4000): void {
    const id = nextId++
    toasts.value.push({ id, severity, summary, detail, life })
    if (life > 0) {
      setTimeout(() => remove(id), life)
    }
  }

  function remove(id: number): void {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  function success(summary: string, detail?: string): void {
    show('success', summary, detail)
  }
  function info(summary: string, detail?: string): void {
    show('info', summary, detail)
  }
  function warn(summary: string, detail?: string): void {
    show('warn', summary, detail)
  }
  function error(summary: string, detail?: string): void {
    show('error', summary, detail, 6000)
  }

  return { toasts, show, remove, success, info, warn, error }
})
